<script lang="ts">
    import { apiBaseOverride } from "../../store"
    import LinkList from "../LinkList.svelte"
    import MedialibImage from "../MedialibImage.svelte"
    import MedialibFile from "../MedialibFile.svelte"

    export let column: BlockColumn

    export let apiBase: string = null
    if (apiBase) $apiBaseOverride = apiBase
</script>

<div
    class="{column.colWidth > 0 ? 'col-md-' + column.colWidth + ' col-12' : 'col-md-auto col-12'}"
    class:align-self-start="{column.verticalAlign == 'top'}"
    class:align-self-center="{column.verticalAlign == 'middle'}"
    class:align-self-end="{column.verticalAlign == 'bottom'}"
>
    {#if column.type == "text"}
        {@html column.text || ""}
        {#if column.features?.length}
            <section class="product-stats">
                <div class="grid">
                    {#each column.features as feature}
                        <div class="col-12">
                            <h4 class="dark-gray-bg">{feature.name}</h4>
                            <div class="description">{@html feature.value}</div>
                        </div>
                    {/each}
                </div>
            </section>
        {/if}
        {#if column.links?.length}
            <div class="button-wrap gap-m" class:tp-m="{column.features?.length}">
                <!-- Buttons sitzen im Wrapper, sollten vermutlich auch flexibel / repeatable sein, mal nur einen, mal zwei, mal keiner -->
                <LinkList links="{column.links}" />
            </div>
        {/if}
    {/if}
    {#if column.type == "image"}
        <div class="background-image">
            <MedialibFile id="{column.image}" let:entry let:src>
                {#if entry.file?.type?.startsWith("video")}
                    <video controls muted autoplay>
                        <source {src} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                {:else}
                    <div class="background-image">
                        <figure>
                            <MedialibImage id="{column.image}" />
                        </figure>
                    </div>
                {/if}
            </MedialibFile>
        </div>
    {/if}
</div>
